import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core';
import { ClientConfigurationService } from 'src/app/core/client-configuration/client-configuration.service';
import { ConfigSettings } from 'src/app/core/client-configuration/config-settings.enum';
import { Appointment } from 'src/app/core/models/appointment.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { InventoryService } from 'src/app/core/services/inventory/inventory.service';
import { TicketProvisioningService } from 'src/app/core/services/ticket-provisioning/ticket-provisioning.service';
import { AddTruckInventoryModalComponent } from './add-truck-inventory-modal/add-truck-inventory-modal.component';
import { AddWarehouseInventoryModalComponent } from './add-warehouse-inventory-modal/add-warehouse-inventory-modal.component';

type AddInventoryModalResponse = OverlayEventDetail<{ forcedModal?: string }>;

@Component({
	selector: 'app-appointment-inventory',
	templateUrl: './appointment-inventory.component.html',
	styleUrls: ['./appointment-inventory.component.scss'],
})
export class AppointmentInventoryComponent {

	pageTitle = 'Inventory';

	activeAppointmentSub: any;
	tabs = [
		{ href: 'active', title: 'Active (0)' },
		{ href: 'add', title: 'Add (0)' },
		{ href: 'remove', title: 'Remove (0)' },
	];
	appointment: Appointment;
	modalConfig: { canToggle: boolean; useTruck: boolean; };
	allowProvisioning = false;

	constructor(
		private activatedRoute: ActivatedRoute,
		private appointmentService: AppointmentService,
		private modalController: ModalController,
		private inventoryService: InventoryService,
		private clientConfig: ClientConfigurationService,
		private ticketProvisioningService: TicketProvisioningService,
	) { }

	async ionViewWillEnter() {
		const id = this.activatedRoute.snapshot.parent.params?.id;
		this.appointment = await this.appointmentService.getLocalAppointment(id);
		this.updateTabTitles(this.appointment);
		this.updateTabTitlesAfterSync();
		this.modalConfig = await this.inventoryService.getAddInventoryModalConfig();
		this.allowProvisioning = await this.clientConfig.hasFeature(ConfigSettings.ShowProvisionTab);
	}

	ionViewWillLeave() {
		this.activeAppointmentSub.unsubscribe();
	}

	updateTabTitles(appointment: Appointment) {
		const activeItems = appointment.inventory.filter(i => i.statusId == 1 && i.originalStatusId == 1);
		this.tabs[0].title = `Active (${activeItems.length})`;

		const toBeAddedItems = appointment.inventory.filter(i => i.statusId == 4);
		this.tabs[1].title = `Add (${toBeAddedItems.length})`;

		const toBeRemovedItems = appointment.inventory.filter(i => i.statusId == 5);
		this.tabs[2].title = `Remove (${toBeRemovedItems.length})`;
	}

	updateTabTitlesAfterSync() {
		this.activeAppointmentSub = this.appointmentService.activeAppointment$
			.subscribe(newAppointment => {
				if (newAppointment) {
					this.updateTabTitles(newAppointment);
				}
			});
	}

	async onClickAddInventory(forcedModal?: string): Promise<void> {
		const component = (!forcedModal && this.modalConfig.useTruck) || forcedModal === 'TRUCK'
			? AddTruckInventoryModalComponent
			: AddWarehouseInventoryModalComponent;

		const modal = await this.modalController.create({
			component,
			componentProps: {
				appointment: this.appointment,
				...this.modalConfig,
			},
			cssClass: 'full-screen-modal',
		});

		await modal.present();
		modal.onDidDismiss().then(
			async (response: AddInventoryModalResponse) => {
				if (response.data.forcedModal) {
					await this.onClickAddInventory(response.data.forcedModal);
				}
			}
		);
	}

	async provisionChanges() {
		await this.ticketProvisioningService.provisionChanges(this.appointment.id);
	}

}
